module.exports = __webpack_public_path__ + "img/youxiang@3x.979e69c2.svg";